import axios from "axios";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getScriptConfigs(payload) {
    const result = await axios.post(apiUrl + "/script/get/config",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function blockScriptConfigs(payload) {
    const result = await axios.post(apiUrl + "/script/block",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const ScriptConfigService = {
    getScriptConfigs,
    blockScriptConfigs
}